export default {
  token: '',
  gender: '',
  name: '',
  phone: '',
  phoneHide: '',
  phone_countryCode: '852',
  email: '',
  member:null,
  memberAddress:[],
  itemsLimit: 999,
  orderMode: '',
  orderType: -1,
  asapOrder: true,
  items: [],
  amount: 0,
  amountWithoutDiscount:0,
  deliveryCharge:0,  
  amountWithoutDeliveryCharge:0,
  packingCharge:0,
  minCharge:0,
  deliveryMethod: null,
  shopArea:"",
  shopDistrict:"",
  shop: null,
  location: null,
  address: '',
  address_full_1: '',
  address_full_2: '',
  address_full_3: '',
  addressDetails: null,
  remark:'',
  remarkDelivery:'',
  remarkDelivery_en:'',
  remarkDelivery_zh:'',
  //remarkDeliveryObj:{"code": "-1", "msg_1": "", "msg_2": ""},
  remarkDeliveryObj:[], // change from object to array on 20230726
  readyTime:null,
  needCutlery: false,
  usedECash:0,
  couponCode: "",
  coupons:[],
  discounts:[],
  device:'',
  prepareTime:0,
  prepareTimeMin:0,
  pickupShopCode: null,
  pickupShop: null,
  savePreferShop: false,
  disableDiscount: false,
  paymentCampaign:null,
  init() {
    this.loadCart();
  },
  reset() {
    this.itemsLimit = 999;
    //this.token="";
    //this.member=null;
    this.gender = "";
    this.name = "";
    this.phone = "";
    this.phoneHide = "";
    this.phone_countryCode = "852";
    this.email = "";
    this.orderMode = "";
    this.orderType = -1;
    this.asapOrder = true;
    this.items = [];
    this.amount = 0;
    this.amountWithoutDiscount = 0;
    this.deliveryCharge = 0;    
    this.amountWithoutDeliveryCharge = 0;
    this.packingCharge = 0;
    this.minCharge = 0;
    this.deliveryMethod = null;
    this.shopArea = "";
    this.shopDistrict = "";
    this.shop = null;
    this.location = null;
    this.address="";
    this.address_full_1="";
    this.address_full_2="";
    this.address_full_3="";
    this.addressDetails=null;
    this.remark = '';
    this.remarkDelivery='';
    //this.remarkDeliveryObj={"code": "-1", "msg_1": "", "msg_2": ""};
    this.remarkDeliveryObj=[];  // change from object to array on 20230726
    this.readyTime = null;
    this.usedECash = 0;
    this.couponCode = "";
    this.coupons = [];
    this.discounts = [];
	this.device = '';
    this.needCutlery = false;
    this.prepareTime = 0;
    this.prepareTimeMin = 0;
    this.pickupShopCode = null;
    this.pickupShop = null;
    this.savePreferShop = false;
    this.disableDiscount = false;
    this.paymentCampaign = null;
    this.saveCart();
  },
  resetSessionTimeout() {
    this.itemsLimit = 999;
    this.token="";
    this.member=null;    
    this.memberAddress=[];    
    this.gender = "";
    this.name = "";
    this.phone = "";
    this.phoneHide = "";
    this.phone_countryCode = "852";
    this.email = "";
    this.usedECash = 0;
    this.couponCode = "";
    this.coupons = [];
    this.discounts = [];
	this.device = '';
    this.needCutlery = false;
    this.prepareTime = 0;
    this.prepareTimeMin = 0;
    this.pickupShopCode = null;
    this.pickupShop = null;
    this.savePreferShop = false;
    this.disableDiscount = false;
    this.paymentCampaign = null;
    this.saveCart();
  },
  loadFile(url, cb) {
    var path = '/files/menu/';
    if ((this.shop.priceZone || '') != '') path += this.shop.priceZone + '/';
    //console.log("path", path + url);
    return $.get(path + url + '.json?rand='+(Math.random()*10000000), (data) => {
      cb(data);
    }, 'JSON')
  },
  loadFileAsync(url, cb) {
    var path = '/files/menu/';
    if ((this.shop.priceZone || '') != '') path += this.shop.priceZone + '/';
    return $.ajax({
        type: "GET",
        url: path + url + '.json?rand='+(Math.random()*10000000),
        async: false,        
        success: (data) => {
            cb(data);
        },
    });
  },
  itemCount(not_in_arr) {
    if (not_in_arr == undefined) not_in_arr = [];
    var c = 0;
    this.items.forEach(i => {
        if (!not_in_arr.includes(i.id)) {
            if (i.qty > 0) c += i.qty;
        }
    })
    return c;
  },
  discountAmount() {
    var amount = 0;
    $.each(this.discounts, (i, d) => { amount += d.price });
    return amount;
  },
  addItem(item, index) {

      // load cart before update
      this.loadCart();

    //console.log('cart.addItem', item, index);
    if (index == undefined) index = -1;
    if (index == -1) {
      if (item.couponCode) this.items = this.items.filter((i) => i.couponCode == undefined) // remove coupon before add new coupon
      this.items.push(item);
    } else this.items[index] = item;

    // no need to updateCart in this version because will call api after addItem
    //this.updateCart();
    //this.saveCart();
  },
  /*updateCart() {
    var amount = 0;
    for (var i = this.items.length - 1; i >= 0; i--) {
      if (this.items[i].qty < 1) this.items.splice(i, 1);
      else amount += (this.items[i].discountPrice || this.items[i].price) * this.items[i].qty;
    }
    this.amount = amount;
  },*/
  updateCart() {
    var amount = 0;
    for (var i = this.items.length - 1; i >= 0; i--) {
      if (this.items[i].qty < 1) this.items.splice(i, 1);
      else amount += (this.items[i].discountPrice || this.items[i].price) * this.items[i].qty;
    }
    this.amountWithoutDiscount = amount;
    for (var i = 0; i < (this.disocunt || []).length; i++) {
        amount = this.disocunt[i].price;
    }
    this.amountWithoutDeliveryCharge = amount;
    this.amount = this.amountWithoutDeliveryCharge + (this.deliveryCharge || 0);

    if (this.packingCharge > 0) {
        this.amount = this.amount + this.packingCharge;
    }

    if (this.usedECash > 0) {
        this.amount = this.amount - this.usedECash;
    }

    if (this.amount < 0) {
        this.amount = 0;
    }
  },
  loadCart() {
    var cartSaveTime = window.localStorage.getItem('cartSaveTime') || 0;
    if ((new Date()).getTime() - cartSaveTime > 60 * 60 * 1000) return;
    var _tmpCart = JSON.parse(window.localStorage.getItem('cartList') || '{}');
    $.extend(this, _tmpCart);
  },
  saveCart() {
    window.localStorage.setItem('cartSaveTime', (new Date()).getTime());
    window.localStorage.setItem('cartList', JSON.stringify(this));
  },
  clearCart() {
    this.items = [];
    this.amount = 0;
    this.amountWithoutDiscount = 0;
    this.deliveryCharge = 0;
    this.amountWithoutDeliveryCharge = 0;
    this.packingCharge = 0;
    this.minCharge = 0;
    this.usedECash = 0;
    this.couponCode = "";
    this.coupons = [];
    this.discounts = [];
    //this.updateCart();
    this.saveCart();
  },

  removeInvalidItem() {
      for (var i = this.items.length - 1; i >= 0; i--) {
          if (this.items[i].invalid) this.items.splice(i, 1);
      }
      this.updateCart();
  },

  getUsedCouponCode() {
    var arr = [];
    for (var i = this.items.length - 1; i >= 0; i--) {
      if ((this.items[i].couponCode || '') != '') arr.push(this.items[i].couponCode);
    }
    return arr;
  },
  getItemTimeSlot(item, date) {
    if (item.timeRange && item.timeRange.length) {
      var f = true;
      var now = date || moment();
      var nowTimeStamp = parseInt(now.format("X"),10);
      $.each(item.timeRange, (i, o) => {
        if (
          o.datActive <= nowTimeStamp &&
          nowTimeStamp <= o.datExpire + ""
        ) {
          if (o.date.indexOf(parseInt(now.format("e"),10)) >= 0) {
            //if (o.timeStart <= now.format("HHmm") && now.format("HHmm") <= o.timeEnd) { // for check time is not end as 00 (eg: 11:59)
            if (o.timeStart <= now.format("HHmm") && now.format("HHmm") < o.timeEnd) { // for check time is end as 00 (eg: 12:00)
              // console.log('0', o)
              f = false;
              return false;
            }
            else {
              // console.log('1', o, o.timeStart, now.format("HHmm"), o.timeEnd)
            }
          }
          else {
            // console.log('2', o, o.date, parseInt(now.format("e"),10))
          }
        } else {
          // console.log('3', o, o.datActive + "", now.format("X"), o.datExpire + "")
        }
      });
      if (f) return false;
    }
    return true;
  },
  getShopOpen(shop, isHoliday, date, time) {
    //console.log(shop);
    if(shop == null || shop == undefined) {
        return false;
    }
    if (time == undefined) time = moment(date).hour() * 100 + moment(date).minute(); 
    if (shop.businessHours == null || shop.businessHours == undefined || !shop.businessHours) return true;
    var businessHour = [];
    if (isHoliday) businessHour = shop.businessHours.filter(x => x.date == '' + 7);
    if (businessHour.length == 0) businessHour = shop.businessHours.filter(x => x.date == '' + moment(date).day());
    if (businessHour.length == 0) return false;
    var f = false;
    $.each(businessHour[0].time, (i, t) => {
      var a = t.split("-");
      //if (parseInt(a[0],10) <= time && time <= parseInt(a[1],10)) { // for check time is not end as 00 (eg: 11:59)
      if (parseInt(a[0],10) <= time && time < parseInt(a[1],10)) { // for check time is end as 00 (eg: 12:00)
        f = true;
        return false;
      }
    });
    return f;
  },
  getShopCloseTime(shop, isHoliday, date, time) {
    //console.log(shop);
    if(shop == null || shop == undefined) {
        return '';
    }
    if (time == undefined) time = moment(date).hour() * 100 + moment(date).minute(); 
    if (shop.businessHours == null || shop.businessHours == undefined || !shop.businessHours) return '';
    var businessHour = [];
    if (isHoliday) businessHour = shop.businessHours.filter(x => x.date == '' + 7);
    if (businessHour.length == 0) businessHour = shop.businessHours.filter(x => x.date == '' + moment(date).day());
    if (businessHour.length == 0) return '';
    var res = '';
    $.each(businessHour[0].time, (i, t) => {
      var a = t.split("-");
      //if (parseInt(a[0],10) <= time && time <= parseInt(a[1],10)) { // for check time is not end as 00 (eg: 11:59)
      if (parseInt(a[0],10) <= time && time < parseInt(a[1],10)) { // for check time is end as 00 (eg: 12:00)
        res = a[1];
        return false;
      }
    });
    return res;
  },

    getOrderTypeByTypeCode(orderTypeCode) {
        var t = "2";
        if (orderTypeCode == "delivery") {
            t = "1";
            this.pickupShopCode = null;
            this.pickupShop = null;
        } else if (orderTypeCode == "pickup") {
            t = "2";
            this.pickupShopCode = null;
            this.pickupShop = null;
        }
        else if (orderTypeCode == "pickupShop") {
            t = "2"; // will save orderType = 2 in Order and check pickupShopCode is not null
        }
        return t;
    },
  updateCartOrderInfo(order_info, lang_code) {
    //this.orderType = order_info.order_type == "delivery" ? "1" : "2";
    this.orderType = this.getOrderTypeByTypeCode(order_info.order_type);
    
    
    if (order_info.order_address != null) {
        if (order_info.order_type == "delivery") {
            this.address = order_info.order_address['address_full_' + lang_code];
            this.address_full_1 = order_info.order_address['address_full_zh'];
            this.address_full_2 = order_info.order_address['address_full_en'];
            this.address_full_3 = order_info.order_address['address_full_sc'];
            this.location = order_info.order_address['location'];
        }
        else {

            if (order_info.order_mode == "shopping") {
                //this.address = "";
                //this.address_full_1 = "";
                //this.address_full_2 = "";
                //this.address_full_3 = "";
                this.location = null;
            }
            else {
                this.address = "";
                this.address_full_1 = "";
                this.address_full_2 = "";
                this.address_full_3 = "";
                this.location = null;
            }
        }
    }

    if (order_info.order_contact_info != null) {
        this.name = order_info.order_contact_info['name'];
        this.phone = order_info.order_contact_info['tel'];
        this.phone_countryCode = order_info.order_contact_info['tel_countryCode'];
        this.email = order_info.order_contact_info['email'];
    }
  },


}